// @ts-nocheck
import { createVuetify } from "vuetify";
import "vuetify/styles";
// Remove direct MDI font import to avoid path issues
// import "@mdi/font/css/materialdesignicons.css";


// Import Vuetify components
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Explicitly import stepper components to ensure they're available
import {
  VStepper,
  VStepperHeader,
  VStepperItem,
  VStepperWindow,
  VStepperWindowItem,
  VAutocomplete,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelTitle,
  VExpansionPanelText,
  VCheckbox
} from 'vuetify/components'

import IconAddMoney from "@/components/icons/IconAddMoney.vue";
import IconAlert from "@/components/icons/IconAlert.vue";
import IconArrowDownload from "@/components/icons/IconArrowDownload.vue";
import iconAccountDetail from "@/components/icons/IconAccountDetail.vue";
import IconBlockHelper from "@/components/icons/IconBlockHelper.vue";
import IconCard from "@/components/icons/IconCard.vue";
import IconCash from "@/components/icons/IconCash.vue";
import IconCheck from "@/components/icons/IconCheck.vue";
import IconCheckCircle from "@/components/icons/IconCheckCircle.vue";
import IconChevronLeft from "@/components/icons/IconChevronLeft.vue";
import IconContentCopy from "@/components/icons/IconContentCopy.vue";
import IconCreditCardClock from "@/components/icons/IconCreditCardClock.vue";
import IconCreditCardRefund from "@/components/icons/IconCreditCardRefund.vue";
import IconDashboard from "@/components/icons/IconDashboard.vue";
import IconDotsHorizontal from "@/components/icons/IconDotsHorizontal.vue";
import IconDropDown from "@/components/icons/IconDropDown.vue";
import IconHelp from "@/components/icons/IconHelp.vue";
import IconMenu from "@/components/icons/IconMenu.vue";
import IconPdf from "@/components/icons/IconPdf.vue";
import IconSettings from "@/components/icons/IconSettings.vue";
import IconSortUp from "@/components/icons/IconSortUp.vue";
import IconSwapHorizontal from "@/components/icons/IconSwapHorizontal.vue";
import IconTextBoxMultiple from "@/components/icons/IconTextBoxMultiple.vue";
import IconTransferMoney from "@/components/icons/IconTransferMoney.vue";
import IconWallet from "@/components/icons/IconWallet.vue";
import IconInternalCredit from "@/components/icons/IconInternalCredit.vue";
import IconExternalCredit from "@/components/icons/IconExternalCredit.vue";
import IconInternalTransfer from "@/components/icons/IconInternalTransfer.vue";
import IconExternalTransfer from "@/components/icons/IconExternalTransfer.vue";
import IconCurrencyExchange from "@/components/icons/IconCurrencyExchange.vue";
import IconCurrencyExchangeMenu from "@/components/icons/IconCurrencyExchangeMenu.vue";
import IconFee from "@/components/icons/IconFee.vue";
import IconRepeatRound from "@/components/icons/IconRepeatRound.vue";
import IconBoldArrowRight from "@/components/icons/IconBoldArrowRight.vue";
import IconCurrencyForex from "@/components/icons/IconCurrencyForex.vue";

export default createVuetify({
  components: {
    ...components,
    VStepper,
    VStepperHeader,
    VStepperItem,
    VStepperWindow,
    VStepperWindowItem,
    VAutocomplete,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelTitle,
    VExpansionPanelText,
    VCheckbox
  },
  directives,
  icons: {
    defaultSet: "mdi",
    sets: {
      mdi: {
        // MDI icons are loaded via CDN in index.html
      },
      custom: {
        iconInternalCredit: IconInternalCredit,
        iconExternalCredit: IconExternalCredit,
        iconInternalTransfer: IconInternalTransfer,
        iconExternalTransfer: IconExternalTransfer,
        iconCurrencyExchange: IconCurrencyExchange,
        iconCurrencyExchangeMenu: IconCurrencyExchangeMenu,
        iconFee: IconFee,
        iconDashboard: IconDashboard,
        iconCash: IconCash,
        iconCard: IconCard,
        iconHelp: IconHelp,
        iconSettings: IconSettings,
        iconWallet: IconWallet,
        iconDotsHorizontal: IconDotsHorizontal,
        iconMenu: IconMenu,
        iconArrowDownload: IconArrowDownload,
        iconAccountDetail: iconAccountDetail,
        iconSwapHorizontal: IconSwapHorizontal,
        iconAddMoney: IconAddMoney,
        iconCreditCardRefund: IconCreditCardRefund,
        iconDropDown: IconDropDown,
        iconCheck: IconCheck,
        iconCheckCircle: IconCheckCircle,
        iconTransferMoney: IconTransferMoney,
        iconTextBoxMultiple: IconTextBoxMultiple,
        iconChevronLeft: IconChevronLeft,
        iconCreditCardClock: IconCreditCardClock,
        iconAlert: IconAlert,
        iconBlockHelper: IconBlockHelper,
        iconContentCopy: IconContentCopy,
        iconPdf: IconPdf,
        iconSortUp: IconSortUp,
        iconRepeatRound: IconRepeatRound,
        iconBoldArrowRight: IconBoldArrowRight,
        iconCurrencyForex: IconCurrencyForex,
      },
    },
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#1ca55c",
          orangeLight1: "#FFF0DE",
          secondary: "#050038",
          gray: "#AFAFAF",
          gray2: "#E5E5E5",
          gray3: "#F3F3F3",
          gray4: "#F8F8F8",
          gray5: "#808080",
          black: "#000000",
          black2: "#292931",
          black3: "#414247",
          white: "#fff",
          purple: "#45109F",
          orangeLight: "#FFF0DE",
          orangeLight2: "#FFE0BC",
          orangeLight3: "#F0C591",
          green: "#38C357",
          success: "#38C357",
          red: "#EF1D26",
          yellow: "#FEE500",
          status_active: "#38C357",
          status_not_active: "#AFAFAF",
          status_closing: "#45109F",
          status_closed: "#000000",
          status_soft_block: "#1ca55c",
          status_hard_block: "#EF1D26",
          white_black: "#fff",
          gray4_black: "#F8F8F8",
          gray4_black3: "#F8F8F8",
          gray2_black3: "#E5E5E5",
          gray2_black2: "#E5E5E5",
          gray2_gray5: "#E5E5E5",
          white_black2: "#fff",
          white_black4: "#fff",
          gray5_gray: "#808080",
          gray4_black2: "#F8F8F8",
          black2_white: "#292931",
          gray_white: "#AFAFAF",
          gray_gray5: "#AFAFAF",
          black_white: "#000",
          orangeLight1_black: "#FFF0DE",
          orangeLight_black2: "#FFF0DE",
        },
      },
      dark: {
        colors: {
          primary: "#1ca55c",
          orangeLight1: "#FFF0DE",
          secondary: "#050038",
          gray: "#AFAFAF",
          gray2: "#E5E5E5",
          gray3: "#F3F3F3",
          gray4: "#F8F8F8",
          gray5: "#808080",
          black: "#000000",
          black2: "#292931",
          black3: "#414247",
          white: "#fff",
          purple: "#45109F",
          orangeLight: "#FFF0DE",
          orangeLight2: "#FFE0BC",
          orangeLight3: "#F0C591",
          green: "#38C357",
          success: "#38C357",
          red: "#EF1D26",
          yellow: "#FEE500",
          status_active: "#38C357",
          status_not_active: "#AFAFAF",
          status_closing: "#45109F",
          status_closed: "#000000",
          status_soft_block: "#1ca55c",
          status_hard_block: "#EF1D26",
          white_black: "#000",
          gray5_gray: "#AFAFAF",
          gray4_black: "#000",
          gray2_black3: "#414247",
          gray_gray5: "#808080",
          black2_white: "#fff",
          gray2_gray5: "#808080",
          gray2_black2: "#292931",
          white_black2: "#292931",
          white_black4: "#1E1E1E",
          gray4_black2: "#292931",
          gray4_black3: "#414247",
          orangeLight_black2: "#292931",
          gray_white: "#fff",
          orangeLight1_black: "#000",
          black_white: "#fff",
        },
      },
    },
  },
});
